import { InfodialogComponent } from './../dialogs/infodialog/infodialog.component';
import { SearchMapComponent } from './searchMap/searchMap.component';
import { FollowUpExtension } from './../shared/followupmapsearchresults.model';
import { SketchbyxydialogComponent } from './../dialogs/sketchbyxydialog/sketchbyxydialog.component';
import { MapsketchdialogComponent } from './../dialogs/mapsketchdialog/mapsketchdialog.component';
import { Http } from '@angular/http';
import { MapdialogComponent } from './../dialogs/mapdialog/mapdialog.component';
import { ConfigurationService } from './../shared/configuration.service';
import { ServiceAreaCodes, CodeDiffDisplay, NewWorkArea, CallerSuppliedGeometry } from './../shared/map.model';
import { MapService } from './../shared/map.service';
import { RootObject, Extension, Feature } from './../shared/mapsearchresults.model';
import { Component, OnInit, ViewEncapsulation, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LocalStorage } from './../shared/localstorage.service';
import { MatDialog, MatMenuTrigger } from '@angular/material';
import { MatSnackBar, MatSnackBarModule } from  '@angular/material';
import { MatExpansionPanel } from '@angular/material';
import { isNullOrUndefined } from "util";
// OpenLayers Imports
import Map from 'ol/map';
import Sphere from 'ol/sphere';
import Overlay from 'ol/Overlay';
import Transform from 'ol/transform'; import View from 'ol/view';
import VectorTileLayer from 'ol/layer/vectortile';
import VectorTileSource from 'ol/source/vectortile';
import TileLayer from 'ol/layer/tile';
import BingMapsSource from 'ol/source/bingmaps';
import TileWMSSource from 'ol/source/tilewms';
import MVT from 'ol/format/mvt';
import Extent from 'ol/extent';
import ZoomControl from 'ol/control/zoom';
import ZoomSliderControl from 'ol/control/zoomslider';
import Draw from 'ol/interaction/draw';
import { debug } from 'util';
import OSM from 'ol/source/osm';
import WktFormat from 'ol/format/wkt';
import VectorLayer from 'ol/layer/vector';
import VectorSource from 'ol/source/vector';
import Snap from 'ol/interaction/snap';
import Projection from 'ol/proj/transforms';
import { TicketService } from '../shared/ticketService';
import { forEach } from '@angular/router/src/utils/collection';
import { apply } from 'ol-mapbox-style';
import * as ol from 'openlayers';
import * as olms from 'ol-mapbox-style';
import stylefunction from 'ol-mapbox-style/stylefunction';
import { count } from 'rxjs/operator/count';
import { TicketCode } from '../shared/ticket';
import { TicketComponent } from '../ticket/ticket.component';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})

export class MapComponent implements OnInit {

  screen = false;
  measureKiloMeter: number;
  measureFeet: number;
  measureMiles: number;
  measureYard: number;
  measureMeters: number;
  searchbing: '';
  polycodes: TicketCode[];
  codeDiff: CodeDiffDisplay[];
  map: Map;
  draw = Draw;
  snap = Snap;
  sketchDraw = Draw;
  sketchSnap = Snap;
  measureDraw = Draw;
  measureSnap = Snap;
  newfeature: string;
  measureSketch;
  qaGeom: string = '';
  qaGeomCodes: TicketCode[];
  originalCodes: TicketCode[];
  returnCodes = true;
  tempFeature: any;
  private mapurl = 'api/Map';
  private _selectionLayer: VectorLayer;
  private _drawLayer: VectorLayer;
  private _sketchPadLayer: VectorLayer;
  private _resultLayer: VectorLayer;
  private _measurePadLayer: VectorLayer;
  private _mapNoteLayer: VectorLayer;
  private _parcelLayer: TileLayer;
  base: string;
  sa: string;
  polysource = new VectorSource({ wrapX: false });
  source = new VectorTileSource({ wrapX: false });
  vector = new VectorTileLayer({
    source: this.source,
  });
  wgs84Sphere = new ol.Sphere(6378137);

  stylenew: string;

  styles: string[] = [
    'Road',
    'Aerial',
    'AerialWithLabels'
  ];
  styleModel: string = this.styles[''];
  layers: TileLayer[];
  interactions: string[] = [
    'Point',
    'LineString',
    'Polygon'
  ];

  sketchinteractions: string[] = [
    'Point',
    'LineString',
    'Polygon'
  ];

  interactionModel: string = this.interactions[''];

  //searches
  searchResults: Extension[] = [];
  searchListResults: Extension[] = [];
  searchSecondListResults: Feature[] = [];
  bingSearchResults: Feature[] = [];
  bingIntersectionResults: Feature[] = [];
  completeSearchResults: RootObject; sketchInteractionModel: string = this.sketchinteractions[''];
  selectedInteraction: string;
  selectedImagery: string;
  selectedSketchInteraction: string;
  token: string;
  search: string[];
  searched: string;
  ticketCounty: string;
  ticketPlace: string;
  gcNumber: string;
  calledSuppliedPoints: CallerSuppliedGeometry[] = [];
  //parcel layer configuration
  parcellayerconfiguration = {
    name: 'parcel-layer',
    label: 'parcel Layer',
    isBase: false,
    minResolution: 0,
    maxResolution: 0
  };

  private lastHoveredFeature: object;
  public mapNoteTooltip = {title: undefined, body: undefined};

  public              mouseGPSCoordinates: {latitude: number, longitude: number};
  private rightClickedMouseGPSCoordinates: {latitude: number, longitude: number};

  @Input() measureTooltip: string;
  @Output() workAreaChange: EventEmitter<NewWorkArea> = new EventEmitter<NewWorkArea>();
  //Search result menu
  @ViewChild("menuTrigger") trigger: MatMenuTrigger;
  @ViewChild('rightClickMenuTrigger') rightClickMenuTrigger: MatMenuTrigger;

  constructor(
    private service: MapService,
    public ticketService: TicketService,
    private http: HttpClient,
    private httpn: Http,
    private localstorage: LocalStorage,
    public dialog: MatDialog,
    public snackBar: MatSnackBar) {
    this.getCodes = this.getCodes.bind(this);
  }
  ngOnInit() {
    this.token = this.localstorage.getItem('token');
    this.originalCodes = this.ticketService.ticket.ticketCodes;
    this.gcNumber = this.ticketService.ticket.number;
    this.ticketCounty = this.ticketService.ticket.workCounty;
    this.ticketPlace = this.ticketService.ticket.workPlace;
    this.addFeatureFunction = this.addFeatureFunction.bind(this);
    this.addSketchFeature = this.addSketchFeature.bind(this);
    this.measureDrawStart = this.measureDrawStart.bind(this);
    this.measureDrawStartAddToolTip = this.measureDrawStartAddToolTip.bind(this);
    this.measureDrawEnd = this.measureDrawEnd.bind(this);
    this.sendToSketch = this.sendToSketch.bind(this);
    this.getBaseVersion = this.getBaseVersion.bind(this);

    this.layers = [
      new TileLayer({
        visible: true,
        preload: Infinity,
        source: new BingMapsSource({
          key: 'AsLgeVO_Cjhfnom4C8C_R6Oyx8b9FDkUCyh7qd-d3l9RL4cUP-gkF-r5rH91a7QN',
          imagerySet: 'Road'
        })
      }),
      new TileLayer({
        visible: false,
        preload: Infinity,
        source: new BingMapsSource({
          key: 'AsLgeVO_Cjhfnom4C8C_R6Oyx8b9FDkUCyh7qd-d3l9RL4cUP-gkF-r5rH91a7QN',
          imagerySet: 'Aerial'
        })
      }),
      new TileLayer({
        visible: false,
        preload: Infinity,
        source: new BingMapsSource({
          key: 'AsLgeVO_Cjhfnom4C8C_R6Oyx8b9FDkUCyh7qd-d3l9RL4cUP-gkF-r5rH91a7QN',
          imagerySet: 'AerialWithLabels'
        })
      })
    ];

    var mapNoteTooltip = document.getElementById('mapNoteTooltip');
    var overlay = new Overlay({ element: mapNoteTooltip });

    this.map = new Map({
      target: 'map',
      layers: this.layers,
      overlays: [overlay],
      view: new View({
        minZoom: 7,
        maxZoom: 18,
        enableRotation: false
      })
    });


    this.map.on('pointermove', (e) => {
        if (e.dragging) // If the user is dragging the map, then the coordinates don't change
            return;

        var feature = this.map.forEachFeatureAtPixel(e.pixel, feature => feature);

        if (this.lastHoveredFeature != feature) {
            if (feature !== undefined && feature.values_.type === 'mapNote') {
                    this.lastHoveredFeature = feature;

                this.mapNoteTooltip.title = feature.values_.name;
                this.mapNoteTooltip.body  = feature.values_.remarks;

                overlay.setPosition(feature.values_.geometry.flatCoordinates);

                mapNoteTooltip.classList.remove('hide');
            }
            else if (this.lastHoveredFeature != undefined) {
                this.lastHoveredFeature = undefined;
                mapNoteTooltip.classList.add('hide');
            }
        }

        const [longitude, latitude] = ol.proj.transform(e.coordinate, 'EPSG:3857', 'EPSG:4326');
        this.mouseGPSCoordinates = {longitude, latitude};
    });

    // On right click of map
    this.map.getViewport().addEventListener('contextmenu', (e) => {
      e.preventDefault();

      const [longitude, latitude] = ol.proj.transform(this.map.getEventCoordinate(e), 'EPSG:3857', 'EPSG:4326');
      this.rightClickedMouseGPSCoordinates = {longitude, latitude};

      var rightClickMenuButton = document.getElementById('rightClickMenuButton');
          rightClickMenuButton.style.left = e.layerX + 5 + 'px';
          rightClickMenuButton.style.top  = e.layerY + 5 + 'px';

      this.rightClickMenuTrigger.openMenu();
    });

    this.getBaseVersion();
    this.addSelectionLayer();
    this.processSelectedItem(this.ticketService.ticket.workSite.workArea);
    this.addDrawLayer();
    this.addSketchPadLayer();
    this.addResultLayer();
    this.addMeasurePadLayer();
    this.addMapNoteLayer();

    const tooltipSpan = document.getElementById('measureTooltip');
    document.onmousemove = function (e) {
      tooltipSpan.style.top = (e.clientY + 20).toString() + 'px';
      tooltipSpan.style.left = (e.clientX + 20).toString() + 'px';

    };
  }

  getBaseVersion(){
    this.service.getBaseVersion('base', this.token, this.localstorage.getItem('currentState')).subscribe(res => { this.base = res.toString()
        this.service.getBaseVersion('sa', this.token, this.localstorage.getItem('currentState')).subscribe(res => { this.sa = res.toString()
        this.addParcelLayer();
      });
    });
  }
  saveGPSCoordinatesToClipboard(): void {
    var temporaryInputElement = document.createElement("input");

    document.body.appendChild(temporaryInputElement);
    temporaryInputElement.setAttribute('value', this.rightClickedMouseGPSCoordinates.latitude + ', ' + this.rightClickedMouseGPSCoordinates.longitude);
    temporaryInputElement.select();
    document.execCommand("copy");
    document.body.removeChild(temporaryInputElement);
  }

  addParcelLayer(): void {


    var url = 'https://' + this.localstorage.getItem('currentState')+'gc.texas811.org/geocall/api/gis/ogc/'+this.localstorage.getItem('currentState');
    let parcelLayer: TileLayer = new TileLayer({
      layerConfig: this.parcellayerconfiguration,
      preload: Infinity,
      source: new TileWMSSource({
        url: url,
        params: {
          'LAYERS': 'parcels',
          'FORMAT': 'image/png',
          'TRANSPARENT': true,
          'AUTH': this.token,
          'VERSIONBASE': this.base,
          'VERSIONSA': this.sa,
          'TILED': true
        }
      })
    });
    this.map.addLayer(parcelLayer);
  }

  addSelectionLayer(): void {
    let lc = {
      name: 'selection-layer',
      label: 'Selection Layer',
      isBase: false,
      minResolution: 0,
      maxResolution: 0,
      pinnedStyle: '',
    };

    this._selectionLayer = new VectorLayer({
      layerConfig: lc,
      declutter: true,
      renderMode: 'vector',
      source: new VectorSource(),

    });
    this.getStyle().subscribe(res => {
      stylefunction(this._selectionLayer, res, 'selection-layer')
    });


    this.map.addLayer(this._selectionLayer);
  }
  addDrawLayer(): void {
    let lc = {
      name: 'draw-layer',
      label: 'draw Layer',
      isBase: false,
      minResolution: 0,
      maxResolution: 0,
      pinnedStyle: '',
    };

    this._drawLayer = new VectorLayer({
      declutter: true,
      renderMode: 'vector',
      source: new VectorSource(),

    });
    this.map.addLayer(this._drawLayer);
  }

  addSketchPadLayer(): void {
    let lc = {
      name: 'sketchpad-layer',
      label: 'sketchpad Layer',
      isBase: false,
      minResolution: 0,
      maxResolution: 0,
      pinnedStyle: '',
    };

    var source = new VectorSource();

    JSON.parse(this.ticketService.ticket.gps || '[]').forEach(function(gpsPoint) {

        var format = new WktFormat();
        var feature = format.readFeature('POINT(' + gpsPoint.longitude + ' ' + gpsPoint.latitude + ')');
            feature.setProperties({ name: gpsPoint.name});
            feature.getGeometry().transform('EPSG:4326', 'EPSG:3857');

        source.addFeature(feature);
    })

    this._sketchPadLayer = new VectorLayer({
        declutter: true,
        renderMode: 'vector',
        source: source,
    });

    this.map.addLayer(this._sketchPadLayer);

    // Style the gps point label so they are visible to the user
    this.getStyle().subscribe(res => {
        olms.applyStyle(this._sketchPadLayer, res, 'sketchpad-layer');
    });
  }

  addResultLayer(): void {
    let lc = {
      name: 'result-layer',
      label: 'result Layer',
      isBase: false,
      minResolution: 0,
      maxResolution: 0,
      pinnedStyle: '',
    };

    this._resultLayer = new VectorLayer({
      declutter: true,
      renderMode: 'vector',
      source: new VectorSource()
    });
    this.map.addLayer(this._resultLayer);
  }

  addMeasurePadLayer(): void {
    let lc = {
      name: 'measurepad-layer',
      label: 'Measurepad Layer',
      isBase: false,
      minResolution: 0,
      maxResolution: 0
    };

    this._measurePadLayer = new VectorLayer({
      declutter: true,
      renderMode: 'vector',
      source: new VectorSource()
    });
    this.map.addLayer(this._measurePadLayer);
  }

  addMapNoteLayer = () => {
    this._mapNoteLayer = new VectorLayer({
        declutter: true,
        renderMode: 'vector',
        source: new VectorSource(),
    });

    this.map.addLayer(this._mapNoteLayer);

    this.getStyle().subscribe(response => {
        olms.applyStyle(this._mapNoteLayer, response, 'result-layer');
        this.loadMapNotesOnCurrentView();
    });
  }

  addInteraction() {
    var value = this.interactionModel;
    if (value !== '') {
      this.draw = new Draw({
        source: this._drawLayer.getSource(),
        type: this.interactionModel
      });
      this.snap = new Snap({ source: this._drawLayer.getSource() });
      this.map.addInteraction(this.snap);
      this.map.addInteraction(this.draw);
      this._drawLayer.getSource().on('addfeature', this.addFeatureFunction);
    }
  }

  addSketchInteraction() {
    var value = this.sketchInteractionModel;
    if (value !== '') {
      this.sketchDraw = new Draw({
        source: this._sketchPadLayer.getSource(),
        type: this.sketchInteractionModel
      });
      this.sketchSnap = new Snap({ source: this._sketchPadLayer.getSource() });
      this.map.addInteraction(this.sketchSnap);
      this.map.addInteraction(this.sketchDraw);
      this._sketchPadLayer.getSource().on('addfeature', this.addSketchFeature);
    }
  }

  addMeasureInteraction() {
    this.measureDraw = new Draw({
      source: this._measurePadLayer.getSource(),
      type: 'LineString'
    });
    this.measureSnap = new Snap({ source: this._measurePadLayer.getSource() });
    this.map.addInteraction(this.measureSnap);
    this.map.addInteraction(this.measureDraw);
    this.measureDraw.on('drawstart', this.measureDrawStart);
    this.measureDraw.on('drawend', this.measureDrawEnd);
    this._measurePadLayer.getSource().on('addfeature', this.sendToSketch);
  }

  measureDrawStart(event) {
    document.getElementById('measureTooltip').className = 'showtooltip';
    this.measureSketch = event.feature;
    event.feature.getGeometry().transform('EPSG:3857', 'EPSG:4326');
    this.measureSketch.getGeometry().on('change', this.measureDrawStartAddToolTip);
  }

  measureDrawEnd() {
    document.getElementById('measureTooltip').className = 'hidetooltip';

    let length = ''
    if (this.measureMiles < 1) {
      length = this.measureFeet.toFixed(0) + ' ft';
    } else {
      length = this.measureMiles.toFixed(2) + ' mi';
    }
    this.measureSketch.setProperties({
      'name': length
    });
    this.getStyle().subscribe(res => {
      olms.applyStyle(this._sketchPadLayer, res, 'sketchpad-layer');
    });
  }

  sendToSketch() {
    let features = this._measurePadLayer.getSource().getFeatures();
    features.forEach(feature => {
      this._sketchPadLayer.getSource().addFeature(feature);
    });
    this._measurePadLayer.getSource().clear();
  }

  measureDrawStartAddToolTip(event) {
    var length = 0;
    var coordinates = event.target.getCoordinates();
    for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
      var c1 = ol.proj.transform(coordinates[i], 'EPSG:3857', 'EPSG:4326');
      var c2 = ol.proj.transform(coordinates[i + 1], 'EPSG:3857', 'EPSG:4326');
      length += this.wgs84Sphere.haversineDistance(c1, c2);
    }
    var output = '';
    if (length > 100) {
      //conversions from km to ft, km to mi, km to yd
      this.measureKiloMeter = (Math.round(length / 1000 * 100) / 100);
      this.measureFeet = this.measureKiloMeter * 3280.8;
      this.measureMiles = this.measureKiloMeter * 0.62137
      this.measureYard = this.measureFeet / 3;
      output += this.measureKiloMeter.toFixed(3) + 'km';
      output += ' | ' + this.measureMiles.toFixed(3) + ' mi';
      output += ' | ' + this.measureFeet.toFixed(3) + ' ft';
      output += ' | ' + this.measureYard.toFixed(3) + ' yd';
    } else {
      //conversions from m to ft, m to mi, m to yd
      this.measureMeters = (Math.round(length * 100) / 100);
      this.measureFeet = this.measureMeters * 3.28;
      this.measureMiles = this.measureMeters * 0.00062137;
      this.measureYard = this.measureFeet / 3;
      output += this.measureMeters.toFixed(3) + 'm';
      output += ' | ' + this.measureMiles.toFixed(3) + ' mi';
      output += ' | ' + this.measureFeet.toFixed(3) + ' ft';
      output += ' | ' + this.measureYard.toFixed(3) + ' yd';

    }
    this.measureTooltip = output;
  }


  addFeatureFunction(event) {
    var features = this._drawLayer.getSource().getFeatures();
    for (var i = 0, len = features.length; i < len; i++) {
      var feature = features[i];
      if (event.feature !== feature) {
        // clearing all features before adding new one to draw layer
        this.tempFeature = feature;
        this._drawLayer.getSource().removeFeature(feature);
      }
    }
    var currentFeture = event.feature;
    var geometry = currentFeture.getGeometry();
    var newgeom = geometry.transform('EPSG:3857', 'EPSG:4326');
    var newformat = new WktFormat();
    this.newfeature = newformat.writeGeometry(currentFeture.getGeometry());
    if (this.returnCodes) {
      this.getCodes(this.newfeature);
    } else {
      this.returnCodes = true;
    }
    event.feature.getGeometry().transform('EPSG:4326', 'EPSG:3857');
  }


  addSketchFeature(e) {
    if (e.feature.getProperties().name == null) {
      let dialogRef = this.dialog.open(MapsketchdialogComponent, {
        width: '600px'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != 'Cancel') {
          // this._selectionLayer.getSource().clear();
          // this._drawLayer.getSource().clear();
          var features = this._sketchPadLayer.getSource().getFeatures();
          var currentFeture = e.feature;

          e.feature.setProperties({
            'name': result
          });
          this.getStyle().subscribe(res => {
            olms.applyStyle(this._sketchPadLayer, res, 'sketchpad-layer')
          });
        }

      })
    }
  };

  processSelectedItem(geometryWkt: string): void {
    if (!(this.map)) {
      return;
    }
    if (geometryWkt == null) {
      geometryWkt = this.ticketService.ticket.workSite.workArea;
    }
    var format = new WktFormat();
    var feature = format.readFeature(geometryWkt, {
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857'
    });

    this._selectionLayer.getSource().clear();
    this._selectionLayer.getSource().addFeature(feature);
    var geometry = feature.getGeometry();
    this.map.getView().fit(geometry, this.map.getSize());

  }

  clearAll() {
    this._drawLayer.getSource().clear();
    this._sketchPadLayer.getSource().clear();
    this._measurePadLayer.getSource().clear();
    this._resultLayer.getSource().clear();
    this._mapNoteLayer.getSource().clear();
  }
  pan() {
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.snap);
    this.map.removeInteraction(this.sketchDraw);
    this.map.removeInteraction(this.sketchSnap);
    this.map.removeInteraction(this.measureDraw);
    this.map.removeInteraction(this.measureSnap)
  }
  sketchByXY() {
    let dialogRef = this.dialog.open(SketchbyxydialogComponent, {
      width: '600px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != 'Cancel') {
        //getting lat and long and converting it to a point geom and add it as feature to map
        var splitted = result.split(',');
        var lat = splitted[0];
        var lon = splitted[1];
        var point = 'POINT(' + lon + ' ' + lat + ')';
        var format = new WktFormat();
        var feature = format.readFeature(point);
        feature.getGeometry().transform('EPSG:4326', 'EPSG:3857');
        var features = this._sketchPadLayer.getSource().getFeatures();
        var count = features.length + 1;
        var name = 'ref' + count;
        feature.setProperties({
          'name': name
        });
        this.getStyle().subscribe(res => {
          olms.applyStyle(this._sketchPadLayer, res, 'sketchpad-layer');
          this._sketchPadLayer.getSource().addFeature(feature);
          var geometry = feature.getGeometry();
          this.map.getView().fit(geometry, this.map.getSize());
          this.map.getView().setZoom(18);
        });
      }
    });

  }

  loadMapNotesOnCurrentView = () => {
    // var viewBoxCoordinates = ol.proj.transformExtent(this.map.getView().calculateExtent(this.map.getSize()),'EPSG:3857','EPSG:4326'); // [-1, 1, -2, 2]
    const [centerLongitude, centerLatitude] = ol.proj.transform(this.map.getView().getCenter(), 'EPSG:3857','EPSG:4326');

    this.service.getMapNotes(this.token, this.localstorage.getItem('currentState'), centerLongitude, centerLatitude).subscribe(mapNotes => {
        var format = new WktFormat();

        mapNotes.forEach(mapNote => {
            var feature = format.readFeature('POINT(' + mapNote.longitude + ' ' + mapNote.latitude + ')');
                feature.setProperties({type: 'mapNote', ...mapNote});
                feature.getGeometry().transform('EPSG:4326', 'EPSG:3857');

            this._mapNoteLayer.getSource().addFeature(feature);
        })
    });
  }

  selectStyleModel(value) {
    this.styleModel = value;
    if (value !== "") {
      for (var i = 0, ii = this.layers.length; i < ii; ++i) {
        this.layers[i].setVisible(this.styles[i] === this.styleModel);
      }
    }
  }

  selectDrawInteractionModel(value) {
    this.interactionModel = value;
    this.map.removeInteraction(this.sketchDraw);
    this.map.removeInteraction(this.sketchSnap);
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.snap);
    this.map.removeInteraction(this.measureDraw);
    this.map.removeInteraction(this.measureSnap);
    this.addInteraction();
  }
  selectSketchInteractionModel(value) {
    this.sketchInteractionModel = value;
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.snap);
    this.map.removeInteraction(this.sketchDraw);
    this.map.removeInteraction(this.sketchSnap);
    this.map.removeInteraction(this.measureDraw);
    this.map.removeInteraction(this.measureSnap);
    this.addSketchInteraction();
  }
  measureTool() {
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.snap);
    this.map.removeInteraction(this.sketchDraw);
    this.map.removeInteraction(this.sketchSnap);
    this.map.removeInteraction(this.measureDraw);
    this.map.removeInteraction(this.measureSnap);
    this.addMeasureInteraction();
  }

  getCodes(geometry: string) {
    this.screen = true;
    this.service.getServiceAreaCodes(geometry, this.token, this.localstorage.getItem('currentState')).then(ticketCodes => {
      this.polycodes = ticketCodes.ticketCode;
      let origCodes = this.originalCodes.slice(0);
      this.codeDiff = new Array<CodeDiffDisplay>();
      this.polycodes.forEach(code => {
        const index = origCodes.findIndex(x => x.code === code.code);
        let temp = new CodeDiffDisplay();
        temp.code = code.code;
        temp.organizationName = code.organizationName;
        temp.isAdded = code.isAdded;
        temp.isSuppressed = code.isSuppressed;
        temp.isSystemSuppressed = code.isSystemSuppressed;
        temp.organizationFacilities = code.organizationFacilities;
        if (index > -1) {
          temp.diff = 1;
          origCodes.splice(index, 1);
        } else {
          temp.diff = 0;
        }
        this.codeDiff.push(temp);
      });
      origCodes.forEach(code => {
        let temp = new CodeDiffDisplay();
        temp.code = code.code;
        temp.organizationName = code.organizationName;
        temp.isAdded = code.isAdded;
        temp.isSuppressed = code.isSuppressed;
        temp.isSystemSuppressed = code.isSystemSuppressed;
        temp.organizationFacilities = code.organizationFacilities;
        temp.diff = -1;
        this.codeDiff.push(temp);
      });
      this.codeDiff.sort(function (a, b) {
        if (a.diff > b.diff) {
          return 1;
        } else if (a.diff < b.diff) {
          return -1;
        } else {
          if (a.organizationName > b.organizationName) {
            return 1;
          } else {
            return -1;
          }
        }
      });
      let dialogRef = this.dialog.open(MapdialogComponent, {
        width: '600px',
        data: {
          codeDiff: this.codeDiff,
          qaGeom: this.qaGeom
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'saveMapping') {
          this.qaGeom = this.newfeature;
          this.qaGeomCodes = this.polycodes;
          let workArea = new NewWorkArea();
          workArea.geom = this.qaGeom;
          workArea.codes = this.qaGeomCodes;
          this.workAreaChange.emit(workArea);
        } else {
          this._drawLayer.getSource().clear();
          if (this.qaGeom !== '') {
            this.returnCodes = false;
            this._drawLayer.getSource().addFeature(this.tempFeature);
          }
        }
      });
      this.screen = false;
    });
  }

  searchSelect() {

    let dialogRef = this.dialog.open(SearchMapComponent, {
      width: '600px',
      disableClose: true,
      data: {
        county: this.ticketCounty,
        place: this.ticketPlace
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != 'Cancel') {
        this.search = result.split(",");
        this.searched = '';
        if (this.search[2] !== "") {
          this.searched += this.search[2] + " ";
        }
        if (this.search[3] !== "") {
          this.searched += this.search[3] + " ";
        }
        this.searched += this.search[4];
        if (this.search[5] !== "") {
          this.searched += " " + this.search[5];
        }
        if (this.search[6] !== "") {
          this.searched += " " + this.search[6];
        }
        if (this.search[7] !== "") {
          this.searched += " and " + this.search[7];
        }
        this.searched += " in " + this.search[1] + ", " + this.search[0] + " County";
        this.getSearchResults(this.search[0], this.search[1], this.search[2], this.search[3], this.search[4], this.search[5], this.search[6], this.search[7]);
        dialogRef.close();
      }
    });
  }

  //search call to GC to get results
  getSearchResults(county: string, place: string, streetAddress: string, streetPrefix: string, streetName: string, streetType: string, streetSuffix: string, intersection: string) {
    this.screen = true;

    this.searchResults = [];
    this.searchListResults = [];
    this.searchSecondListResults = [];
    this.service.getBingSearchResults(county, place, streetAddress, streetPrefix, streetName, streetType, streetSuffix, intersection, this.token, 'bingSearch', this.localstorage.getItem('currentState')).subscribe(res => {
      this.bingSearchResults = res;
      this.service.getBingSearchResults(county, place, streetAddress, streetPrefix, streetName, streetType, streetSuffix, intersection, this.token, 'intersection', this.localstorage.getItem('currentState')).subscribe(res => {
        this.bingIntersectionResults = res;
      });
    });

    this.service.getSearchResults(county, place, streetAddress, streetPrefix, streetName, streetType, streetSuffix, intersection, this.token, this.localstorage.getItem('currentState')).subscribe(res => {
      this.completeSearchResults = res;
      this.searchResults = res['extension'];
      var index = this.searchResults.findIndex(x => x.display === 'Suggested Property Boundary');
      if (this.bingSearchResults.length > 0) {
        var bingresult = new Extension();
        bingresult.display = 'Bing Best Results';
        bingresult.label = 'Bing Best Results';
        bingresult.feature = this.bingSearchResults;
      }
      if (this.bingIntersectionResults.length > 0) {
        var bingintersectionresult = new Extension();
        bingintersectionresult.display = 'Bing Intersection Results';
        bingintersectionresult.label = 'Bing Intersection Results';
        bingintersectionresult.feature = this.bingIntersectionResults;
      }
      if (index !== -1) {
        if (this.bingSearchResults.length > 0) {
          var feature = this.searchResults[index].feature;
          if (feature == null) {
            this.searchResults.fill(bingresult, 0, 1);
          }
          else {
            this.searchResults.push(bingresult);
          }
        }
        if (this.bingIntersectionResults.length > 0) {
          this.searchResults.push(bingintersectionresult);
        }
        this.searchResults.forEach(element => {
          if (element.feature) {
            this.searchListResults.push(element);
            element.feature.forEach(featureEle => {
              featureEle.extensionName = element.display;
              this.searchSecondListResults.push(featureEle);
            });
          }
        });
        var Feature = this.searchSecondListResults[0];
        this.processSearchSelectedItem(Feature.geometry, Feature.extent);
        this.trigger.openMenu();
        this.screen = false;
      }
    });
  }

  //adding feature to layer for search results
  processSearchSelectedItem(geometryWkt: string, extent: string, searchResult?): void {
    if (!(this.map)) {
      return;
    }

    var format = new WktFormat();
    var feature = format.readFeature(geometryWkt, {
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857'
    });

    this._resultLayer.getSource().clear();
    this._mapNoteLayer.getSource().clear();

    this.getStyle().subscribe(res => {
        olms.applyStyle(this._resultLayer, res, 'result-layer');

        var geometry = feature.getGeometry();
        this.map.getView().fit(geometry, this.map.getSize());

        if (searchResult && searchResult.extensionName === 'Map Notes V3') {
            this.loadMapNotesOnCurrentView();
        }
        else {
            this._resultLayer.getSource().addFeature(feature);
        }
    });
  }
  //getting styles from local json file
  getStyle() {
    return this.http.get('/assets/styles.json');
  }

  showSnackbarMessage(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000
    });
  }
  removeQAGeom() {
    this._drawLayer.getSource().clear();
    this.qaGeom = '';
    this.qaGeomCodes = new Array<TicketCode>();
    let workArea = new NewWorkArea();
    workArea.geom = this.qaGeom;
    workArea.codes = this.qaGeomCodes;
    this.workAreaChange.emit(workArea);
  }
  getCallerSuppliedPoints() {
    this.service.getCallerSuppliedPoints(this.token, this.gcNumber, this.localstorage.getItem('currentState')).subscribe(res => {
      if (!isNullOrUndefined(res)) {
        this.calledSuppliedPoints = res;
        if (!isNullOrUndefined(this.calledSuppliedPoints[0].GeometryWkt) && this.calledSuppliedPoints[0].GeometryWkt !== '') {
          var format = new WktFormat();
          var feature = format.readFeature(this.calledSuppliedPoints[0].GeometryWkt);
          feature.getGeometry().transform('EPSG:4326', 'EPSG:3857');
          var features = this._sketchPadLayer.getSource().getFeatures();
          var name = "CSW";
          feature.setProperties({
            'name': name
          });
          this.getStyle().subscribe(res => {
            olms.applyStyle(this._sketchPadLayer, res, 'sketchpad-layer');
            this._sketchPadLayer.getSource().addFeature(feature);
            var geometry = feature.getGeometry();
            this.map.getView().fit(geometry, this.map.getSize());
            this.map.getView().setZoom(18);
          });
        }
        else {
          let infoDialog = this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
              title: 'No Geometry Found',
              content: 'Caller supplied geometry was not found for this ticket.'
            }
          });
        }
      }
      else {
        let infoDialog= this.dialog.open(InfodialogComponent, {
          width: '500px',
          data: {
            title: 'No Geometry Found',
            content: 'Caller supplied geometry was not found for this ticket.'
          }
        });
      }
    });
  }
}
